import React, {Fragment} from "react";
import {s_char} from "../_signals/s_char";
import {s_char_mods_bew, s_char_mods_tot, s_char_mods_wund} from "../_signals/s_char_mods";
import CharCreate from "./charcreate";
import {s_char_attr_sum} from "../_signals/s_char_attr";

export function displaySchwelleWithMod(schwelle: string) {
    let base = 0;
    let mod = 0;
    const cc = s_char.value.cc_attr;
    switch (schwelle) {
        case 'ts':
            base = s_char.value.tot;
            mod = s_char_mods_tot.value;
            if (!cc) base = CharCreate.assign[s_char_attr_sum('zae').value].ts
            break;
        case 'bs':
            base = s_char.value.bew;
            mod = s_char_mods_bew.value;
            if (!cc) base = CharCreate.assign[s_char_attr_sum('zae').value].bs
            break;
        case 'ws':
            base = s_char.value.wund;
            mod = s_char_mods_wund.value;
            if (!cc) base = CharCreate.assign[s_char_attr_sum('zae').value].ws

    }

    if (mod === 0) return <Fragment>{base}</Fragment>;
    if (mod < 0) return <Fragment>{base} {mod} <span> = {(base + mod)}</span></Fragment>;
    return <Fragment>{base} +{mod} <span> = {(base + mod)}</span></Fragment>;
}
